import { render, staticRenderFns } from "./itherapies.vue?vue&type=template&id=db86ba30&"
import script from "./itherapies.vue?vue&type=script&lang=js&"
export * from "./itherapies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports